import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { ToastContainer } from "react-toastify";
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import "./components/toastComponent/ToastComponent.scss";
import { keycloak } from "./services/keycloak";
import AppRouter from "./AppRouter";
import "./css/common.scss";
import { ValueProvider } from "./utils/contextAPI/contextAPI";
import { eDetail } from "./utils/constants";
import { useEffect } from "react";
import LogoutModal from "./components/template/logoutTemplate";
import LogInModal from "./components/template/loginTemplate";

function App() {
  const [deckId, setDeckId] = useState(null);
  const [userSub, setUserSub] = useState(null);
  const [devices, setDevices] = useState([]);
  const [dimensions, setDimensions] = useState([]);
  const [edetailName, setEdetailName] = useState("");
  const [scheduleLogoutTimer, setScheduleLogoutTimer] = useState(null)
  const [sessionExpiredPopup, setSessionExpiredPopup] = useState(null)
  const [resetLogoutPopup, setResetLogoutPopup] = useState(null)

  const storeUserSession = () => {
    const parsed = keycloak.tokenParsed;
    sessionStorage.setItem("userToken", keycloak.token)
    localStorage.setItem("userToken", keycloak.token);
    localStorage.setItem("userRole", JSON.stringify(parsed.realm_access.roles));
    localStorage.setItem("userEmail", parsed.email);
    localStorage.setItem("userId", parsed.sub);
    localStorage.setItem("currentUserName", parsed.name);
  }

  const eventLogger = (event) => {
    console.log(`Keycloak event triggered ---> ${event}`)
    switch (event) {

      case "onReady":
      case "onAuthSuccess":
        storeUserSession();
        scheduleLogoutTimer()
        break;

      case "onTokenExpired":
        resetLogoutPopup()
        sessionExpiredPopup(true)
        break;

      case "onAuthRefreshSuccess":
        storeUserSession();
        scheduleLogoutTimer();
        break;

      default:
        break;
    }
  }

  function isTokenExpired() {
    const token = sessionStorage.getItem('userToken');
    if(!token) return
    const payload = JSON.parse(atob(token.split('.')[1]));
    if(payload.exp * 1000 < Date.now()){
      sessionStorage.clear();
      keycloak.login({ 
        prompt: 'login',
        redirectUri: window.location.origin 
      });
    }
  }

  useEffect(() => {
    isTokenExpired()
    window.addEventListener('load', isTokenExpired)
    return () => {
      window.removeEventListener("load", isTokenExpired)
    };
  }, [keycloak])

  return (
    <div className="App">
      <ToastContainer />
      <ReactKeycloakProvider
        authClient={keycloak}
        initOptions={{ onLoad: "login-required" }}
        onEvent={eventLogger}
        keycloak={keycloak}
        autoRefreshToken={false}
      >
        <ValueProvider
          value={{
            deckId: deckId,
            setDeckId: setDeckId,
            setEdetailName: setEdetailName,
            edetailName: edetailName,
            userSub: userSub,
            setUserSub: setUserSub,
            devices: devices,
            setDevices: setDevices,
            dimensions: dimensions,
            setDimensions: setDimensions,
          }}
        >
          <AppRouter />
          <LogoutModal register={setScheduleLogoutTimer} registerLogoutPopup={setResetLogoutPopup} />
          <LogInModal register={setSessionExpiredPopup} />
        </ValueProvider>
      </ReactKeycloakProvider>
      <div className="flickeringcol1">
        <span className="flickeringcol2"></span>
        <span className="flickeringcol3"></span>
        <span className="flickeringcol4"></span>
        <span className="flickeringdiv"></span>
        <span className="flickeringHeading"></span>
        <span className="flickeringSubHeading"></span>
        <span className="flickeringPara"></span>
        <span className="flickeringImage"></span>
        <span className="flickeringvideo"></span>
        <span className="flickeringtable"></span>
        <span className="flickeringtabs"></span>
        <span className="flickeringButton"></span>
        <span className="flickeringLink"></span>
        <span className="flickeringform"></span>
        <span className="flickeringLink"></span>
      </div>
    </div>
  );
}

export default App;
